import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { COMPOSED_CLAIMS } from 'constants/composedClaims';

import { selectIsClaimAllowed } from 'store/auth/selectors';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectLoanApplicationControlUI = createSelector(
  selectLoanApplication,
  ({ controlUI }) => controlUI,
);

const selectAvailableTabs = createSelector(
  selectLoanApplicationControlUI,
  ({ availableTabs }) => availableTabs,
);

export const selectAvailableTabsArray = createSelector(selectAvailableTabs, Object.values);

export const selectActiveTabReFetchNeededData = createSelector(
  selectLoanApplicationControlUI,
  ({ isActiveTabReFetchNeeded, triggeredByPendingChanges }) => ({
    isActiveTabReFetchNeeded,
    triggeredByPendingChanges,
  }),
);

export const selectEditingIds = createSelector(
  selectLoanApplicationControlUI,
  ({ editingIds }) => editingIds,
);

export const selectIsEditingSection = memoizeOne(id =>
  createSelector(selectEditingIds, editingIds => editingIds.includes(id)),
);

export const selectIsTabsNavigationDisabled = createSelector(
  selectLoanApplicationControlUI,
  ({ isTabsDisabled }) => isTabsDisabled,
);

export const selectDocumentPanes = createSelector(
  selectLoanApplicationControlUI,
  ({ documentPanes }) => documentPanes,
);

export const selectDocumentPaneSizes = createSelector(
  selectLoanApplicationControlUI,
  ({ documentPaneSizes }) => documentPaneSizes,
);

export const selectOpenDocumentPaneCount = createSelector(
  selectDocumentPanes,
  documentPanes => documentPanes.length,
);

export const selectDocumentPaneHostWidth = createSelector(
  selectLoanApplicationControlUI,
  ({ documentPaneHostWidth }) => documentPaneHostWidth,
);

export const selectIsSaveProgramPermissionsLack = createSelector(
  selectIsClaimAllowed(COMPOSED_CLAIMS.LOAN_APPLICATION_SAVE_WITHOUT_PROGRAM),
  selectIsClaimAllowed(COMPOSED_CLAIMS.LOAN_APPLICATION_CHANGE_PROGRAM),
  (isSaveWithoutProgramAllowed, isChangeProgramAllowed) =>
    !isSaveWithoutProgramAllowed && !isChangeProgramAllowed,
);
